<div class="d-flex flex-row form-group" ngModelGroup="fieldElement-{{ index }}">
    <div class="w-210px">
        <label translate (click)="fieldNgSelect.focus()">Field</label>
        <div>
            <ng-select
                #fieldSelect
                bindLabel="name"
                dropdownPosition="bottom"
                name="fieldKey"
                class="select-control selector"
                placeholder="{{ 'Select field' | translate }}"
                [(ngModel)]="fieldKey"
                [items]="allFields"
                (change)="onSelect()">
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                    <span>{{ item.name }}</span>
                </ng-template>
            </ng-select>
        </div>
    </div>

    @if (fieldKey) {
        <div class="ms-2 w-210px">
            <sb-form-field [formType]="formTypesEnum.inboxSearch" [formField]="fieldKey"> </sb-form-field>
        </div>
    }
</div>
